// 默认函数实例会初始化全部功能；按已有用法只创建加法和 BigNumber 实例。
import { create, addDependencies, bignumberDependencies } from 'mathjs';

const math = create({ addDependencies, bignumberDependencies });
export const add = math.add;
export const bignumber = math.bignumber;
